// Paths for auth_service (/auth).
// When a global store with appName is added, switch to KATE style:
// `/api/auth/${this.store.appName}/send_email/sign_in` and
// `/api/auth/${this.store.appName}/token/login`.
export const APP_NAME = 'applicant_portal';
export const SEND_SIGN_IN_PATH = `/api/auth/${APP_NAME}/send_email/sign_in`;
export const TOKEN_LOGIN_PATH = `/api/auth/${APP_NAME}/token/login`;
export const LOGOUT_PATH = '/api/auth/logout';

// applicant_portal_service paths
export const APPLICANT_PORTAL_API_PREFIX = '/api/applicant-portal';

export const COMPLIANCE_PACK_PATH = `${APPLICANT_PORTAL_API_PREFIX}/compliance-pack`;
export const EMPLOYER_SIGNING_PATH = `${COMPLIANCE_PACK_PATH}/employer-signing`;
export const EMPLOYER_SIGNATURE_PATH = `${EMPLOYER_SIGNING_PATH}/signature`;

export const EMAIL_REGEX = /[^@]+@[^@]+\.[^@]+/;

// Hosted on HubSpot, where the file is replaced in place when the notice changes.
export const PRIVACY_NOTICE_URL =
  'https://cambridgespark.com/hubfs/Documents/LearnerPrivacyNotice-October2026.pdf';
